import React from "react";
import styles from "./ModalNotAble.module.scss";
import { ReactComponent as Edify } from "../../../assets/svg/edify.svg";
import { closeMainModal, ShowNotAbleModal } from "../../../store/actions/profileActions";
import { connect } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";
import { ReactComponent as Publicar } from "../../../assets/svg/publicarProyecto.svg";

const backdrop = {
  visible: {
    opacity: 1,
  },
  hidden: {
    opacity: 0,
  },
};
const modal = {
  hidden: {
    // y: "-100vh",
    // x: "-50%",
    opacity: 0,
  },
  visible: {
    // y: "-50%",
    // x: "-50%",
    opacity: 1,
    transition: { delay: 0.2 },
  },
};

const ModalNotAble = ({ closeMainModal, mainModalConfig, ShowNotAbleModal }) => {
  const { isSuccess, title, body, confirmHandler, customCloseMainModal, yesLabel='si', noLabel = 'Volver' } = mainModalConfig;

  function handleGoBack() {
    if(customCloseMainModal) {
      customCloseMainModal()
    } else {closeMainModal()}
  }

  return (
    <>
      <AnimatePresence exitBeforeEnter>
        <motion.div
          variants={backdrop}
          initial='hidden'
          animate='visible'
          exit='hidden'
          className={styles.MainModal_overlay}
          onClick={closeMainModal}
        ></motion.div>
        <motion.div
          variants={modal}
          initial='hidden'
          animate='visible'
          exit='hidden'
          className={styles.MainModal}
        >
          <div className={styles.edifyIcon}><Edify/> </div>
          <h3>AUN NO DISPONIBLE</h3>
          <p>AUN NO DISPONIBLE</p>
        </motion.div>
      </AnimatePresence>
    </>
  );
};

const mapStateToProps = state => {
  return {
    mainModalConfig: state.general.mainModalConfig,
    showNotAbleModal: state.general.showNotAbleModal
  };
};

export default connect(mapStateToProps, { ShowNotAbleModal })(ModalNotAble);
